import {combineReducers} from "redux";

import whychooseus from "../features/admin/aboutus/whychooseus/Slice";

import whatourclientsay from "../features/admin/aboutus/whatourclientsay/Slice";

import common from "../features/admin/common/Slice";

const aboutus = combineReducers({    
    whychooseus,    
    whatourclientsay,    
    common
});

export default aboutus;